import { apiDownload, apiGet, apiPost, buildApiRoute, getPaged } from "./entityApiShared.js";
import { cmtsDashboardReportApiRoutes } from "../core/api/cmtsDashboardReportApiRoutes.js";
import type { EntityRecord, PageQuery, PagedResult } from "../types/api.types.js";

export type AuditLogDto = EntityRecord;

export const auditApi = {
  listAuditLogs: (query?: PageQuery, signal?: AbortSignal): Promise<PagedResult<AuditLogDto>> => getPaged<AuditLogDto>(cmtsDashboardReportApiRoutes.audit.logs, query, signal),
  getAuditLogDetail: (auditId: string, signal?: AbortSignal): Promise<AuditLogDto> => apiGet<AuditLogDto>(buildApiRoute(cmtsDashboardReportApiRoutes.audit.detail, { auditId }), { signal }),
  exportAuditLogs: (query?: PageQuery, signal?: AbortSignal): Promise<Blob> => apiDownload(buildApiRoute(cmtsDashboardReportApiRoutes.audit.export), { method: "POST", body: { query }, signal }),
  list: (query?: PageQuery, signal?: AbortSignal): Promise<PagedResult<AuditLogDto>> => getPaged<AuditLogDto>(cmtsDashboardReportApiRoutes.audit.logs, query, signal),
};
